import { render, staticRenderFns } from "./ProfilesArchive.vue?vue&type=template&id=5b3958a4&scoped=true&"
import script from "./ProfilesArchive.vue?vue&type=script&lang=js&"
export * from "./ProfilesArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3958a4",
  null
  
)

export default component.exports